<template>
	<dropdown :class='{activeFilter: filtered, rightAlign: right_align, filter}' :text='name' v-model='val' @input='open'>
		<li>
			<checkbox type='info' v-model='sel'>Выбрать всё</checkbox>
		</li>
		 <li role="separator" class="divider"></li>
		<div style='overflow-y: auto; max-height: 300px'>
			<li v-for='i in items'>
				<checkbox type='info' v-model='i.checked'>{{i.value}}</checkbox>
			</li>
		</div>
		 <li role="separator" class="divider"></li>
		<li class='pull-right'>
			<input type="button" class='btn btn-primary' value='Ок' @click='ok'></input>
			<input type="button" class='btn btn-default' value='Отмена' @click='cancel'></input>
		</li>
	</dropdown>
</template>

<script>
	import { dropdown, checkbox } from 'vue-strap'
	import { EventBus } from '../../lib/EventBus'
	import {DB} from '../../constants'
	import moment from 'moment'

	const FILTER = 'get_territory_filter.php'

	export default {
		name: 'TerritoryFilter',
		data () {
			return {
				items: [],
				sel: true,
				val: false,
				filtered: false,
				saved_items: [],
			}
		},
		props: {
			name: '',
			field: '',
			filter: '',
			right_align: {
				default: false
			}
		},
		components: {
			dropdown,
			checkbox
		},
		watch: {
			sel (e) {
				this.items.map(t => {
					t.checked = e
				})
			}
		},
		methods: {
			ok () {
				this.val = false
				let result = []
				for (let i = 0; i < this.items.length; i++) {
					if (this.items[i].checked) {
						result.push(this.items[i].value)
					}
				}

				this.filtered = (result.length !== this.items.length) && (result.length !== 0)

				if (!this.filtered) {
					EventBus.$emit('territory_filter', {field: this.field, value: [], filtered: this.filtered})
					//this.sel = true
				}
				else {
					EventBus.$emit('territory_filter', {field: this.field, value: result, filtered: this.filtered})
					//this.sel = false
				}
			},
			cancel () {
				this.val = false
			},
			open (show) {
				if (show) {
					let where = '('
					for (let f in this.filter) {
						for (let i = 0; i < this.filter[f].length; i++) {
							if (f !== this.field)
								where += `${f} = '${this.filter[f][i]}' or `
						}
						if (f !== this.field) {
							where = this.filter[f].length !== 0 ? where.slice(0,-4) : where
							where += this.filter[f].length !== 0 ? ') and (' : ''
						}
						
					}
					where = where.slice(0,-6)

					let where_range = [] 
					for (let f in this.$parent.filterRange) {
						let filter_name = f
						if(filter_name == 'forest_age')
							filter_name = 'forest_age::int'
						if(this.$parent.filterRange[f].min)
							where_range.push(`${filter_name} >= ${this.$parent.filterRange[f].min}`)
						if(this.$parent.filterRange[f].max)
							where_range.push(`${filter_name} <= ${this.$parent.filterRange[f].max}`)					
					}

					const joined = where_range.join(' and ')
					if(where)
					{
						if(joined)
							where = where + ' and ' + joined
					} else 
					{
						if(joined)
							where = joined
					}

					let params = '?field=' + this.field + '&filter=' + where

					fetch(DB + FILTER + params, {credentials: 'include'})
					.then(res => res.json())
					.then(res => {
						if (res) {
							let arr = res.map((r,i) => {
								return {
									value: r[this.field] ? (this.field !== 'act_placement_date' ? r[this.field] : moment(r[this.field], 'YYYY-MM-DD').format('DD.MM.YYYY')) : '',
									checked: true
								}
							})

							for (let i = 0; i < arr.length; i++) {
								for (let j = 0; j < this.items.length; j++) {

									if (arr[i].value === this.items[j].value) {
										arr[i].checked = this.items[j].checked
									}
								}
							}

							this.items = arr
						}
						else {
							this.items = []
						}
					})
					.catch(err => console.log(err))
				}
			}
		},
		created () {
			EventBus.$on('clearTerritoryFilters', f => {
				this.filtered = false
				this.sel = true
				this.items = []
			}) 
		},
		beforeDestroy () {
			EventBus.$off('clearTerritoryFilters')
		}
	}

</script>

<style>
	.activeFilter, .activeFilter > .dropdown-toggle {
		background-color: lightgreen !important;
		/*color: white;*/
	}

	div.btn-group {
		width: 100%;
	}

	div.filter, button.dropdown-toggle {
		width: 100%;
		/*height: 40%;*/
		padding-top: 0px;
		padding-bottom: 0px;
	}

	button.dropdown-toggle {
	 	font-weight: bold; 
		border: none;
	}

	ul.dropdown-menu {
		padding-left: 10px;
		padding-right: 10px;
		/*max-height: 500px;*/
		min-width: 200px;
		/*overflow-y: auto;*/
	}

	.rightAlign > .dropdown-menu {
		right: 0;
    	left: unset;
	}
</style>


// WEBPACK FOOTER //
// TerritoryFilter.vue?852a5a1a